import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { SESSION_STORAGE } from '@shared/constants';
import { storageManager } from '@shared/storage';
import { ensureActiveOrg, getActiveUserId, restoreActiveAccountUserId } from '@shared/utils';

export const OrgPrefixRedirectGuard: CanMatchFn = (_route, segments) => {
  const router = inject(Router);
  const navigation = router.currentNavigation();
  const queryParams = navigation?.extras?.queryParams || {};
  const preserveFragment = navigation?.extras?.preserveFragment === true;

  let activeUserId = getActiveUserId();
  if (!activeUserId) {
    const restoreActiveAccount = restoreActiveAccountUserId(0);
    if (!restoreActiveAccount) {
      storageManager.session.set(SESSION_STORAGE.REDIRECT_URI_KEY, location.pathname + location.search);
      return router.createUrlTree(['/auth/login'], { queryParams: queryParams });
    }
    activeUserId = getActiveUserId();
  }

  const orgId = ensureActiveOrg(activeUserId);
  if (!orgId) {
    return router.createUrlTree(['/account-dashboard'], { queryParams: queryParams });
  }

  const rest = segments.map(seg => seg.path);
  return router.createUrlTree(['/org', orgId, ...rest], {
    queryParams: queryParams,
    preserveFragment: preserveFragment
  });
};
